import data from "../../.sourceflow/blog.json";
import CollectionHelper from "@/helpers/CollectionHelper";

export const blog_helper = new CollectionHelper(data);
